export const Props = () => ({
  //ID поста
  postId: {
    type: Number,
    required: true,
  },

  //Спрятать контекстное меню
  hideMenu: {
    type: Boolean,
    default: false,
    required: false,
  },
});